import axios from 'axios';

// In production (deployed), use relative URL. In development, use env variable.
const getBackendUrl = () => {
  // If we're on the preview domain, use the env variable
  if (window.location.hostname.includes('preview.emergentagent.com')) {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  // For production/custom domains, use relative URL (same origin)
  return '';
};

const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;

let authToken = null;

// Check if user wants to stay signed in
const getStorageType = () => {
  // If 'rememberMe' flag is set, use localStorage, otherwise sessionStorage
  return localStorage.getItem('rememberMe') === 'true' ? localStorage : sessionStorage;
};

export const setAuthToken = (token, rememberMe = true) => {
  authToken = token;
  if (token) {
    // Store the remember preference
    if (rememberMe) {
      localStorage.setItem('rememberMe', 'true');
      localStorage.setItem('auth_token', token);
      sessionStorage.removeItem('auth_token');
    } else {
      localStorage.setItem('rememberMe', 'false');
      sessionStorage.setItem('auth_token', token);
      localStorage.removeItem('auth_token');
    }
  } else {
    // Clear all tokens on logout
    localStorage.removeItem('auth_token');
    sessionStorage.removeItem('auth_token');
    localStorage.removeItem('rememberMe');
  }
};

export const getAuthToken = () => {
  if (!authToken) {
    // Check localStorage first (for remembered sessions)
    authToken = localStorage.getItem('auth_token');
    // If not found, check sessionStorage (for temporary sessions)
    if (!authToken) {
      authToken = sessionStorage.getItem('auth_token');
    }
  }
  return authToken;
};

export const api = axios.create({
  baseURL: API,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;